import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CloseIcon from '@mui/icons-material/Close';


export const BaseModal = ({ open, setOpen, children, width="550px" }) => {
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
        <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: width,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius:"10px"
            }}
          >
            <div className="icons-container" style={{
                position: "absolute",
                left: "93%",
                top: "2%"
            }}>
                <CloseIcon onClick={() => setOpen(false)} className="icon"/>

            </div>
            {children}
            </Box>
            </Fade>
      </Modal>
    </div>
  );
};
